export class DtoCodigoNombre {
    Codigo: string = '';
    Nombre: string = '';
}